<div *ngIf="!imageError; else error" class="img-holder">
  <img
    [alt]="alt"
    [src]="url"
    [hidden]="loading"
    (load)="loading = false"
    (error)="imageError = true"
    class="img-thumbnail"
  />
  <nz-spin nzSimple *ngIf="loading" nzSize="large">Loading image...</nz-spin>
</div>
<ng-template #error>
  <div class="img-block">
    <img class="img-thumbnail" src="/assets/emmet_confused.jpg" alt="Confused Emmet figure" />
    No Image found
  </div>
</ng-template>
